import CellHOC from '@platform/react/hoc/list/cell'
import LabeledHOC from '@platform/react/hoc/list/labeled'
import { ListItemCellTicketDevice } from 'ui/Element/List/Item/Cell/Ticket/Device'

export default CellHOC(
  LabeledHOC(
    props => props.labels.device,
    ListItemCellTicketDevice,
  ),
)
